export const MERGE_AND_ACQUISITION_TYPE_KEYS = {
  mAndA: "m&a",
  mergeAndAcquisition: "merge&acquisition",
} as const;

export const MERGE_AND_ACQUISITION_INPUT_TYPE_LIST = Object.values(
  MERGE_AND_ACQUISITION_TYPE_KEYS,
) as string[];
